import {
  ErrorHandler as BaseErrorHandler,
  EnvironmentProviders,
  makeEnvironmentProviders,
} from '@angular/core';
import { ErrorHandler } from './error-handler';

export const provideErrorHandler = (): EnvironmentProviders =>
  makeEnvironmentProviders([
    {
      provide: BaseErrorHandler,
      useClass: ErrorHandler,
    },
  ]);
